import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Msjs, Msjs_Validations, PatternsRegex, SistType } from 'src/app/shared/cons/common';
import { Icons } from 'src/app/shared/cons/icons';
import { UIService } from 'src/app/shared/services/ui.services';
import { DatosPlataforma } from '../../../cons/common';
import { Utils } from 'src/app/shared/helpers/utils';
import { NgForm } from '@angular/forms';
import { SnackBarType } from 'src/app/shared/types/snackbar-type';
import { CodigoRegistroBlService } from '../../consola/gestionar-codigo-registro/services/codigo-registro-bl.service';
import { FunctionsService } from 'src/app/shared/services/functions.service';
import * as moment from "moment";

@Component({
  selector: 'app-solicitar-codigo',
  templateUrl: './solicitar-codigo.component.html',
  styleUrls: ['./solicitar-codigo.component.scss']
})
export class SolicitarCodigoComponent implements OnInit {
  CLOSE:string = Icons.CLOSE;
  CANCEL:string = Icons.CANCEL;
  isLoading:boolean=false;
  readonly DatosPlataforma: typeof DatosPlataforma = DatosPlataforma;
  onlyNumbers = Utils.InputOnlyNumbers;
    //constantes
  readonly Msjs_Validations:typeof Msjs_Validations = Msjs_Validations;  
  readonly PatternsRegex: typeof PatternsRegex = PatternsRegex;



  constructor(
    private uiService:UIService,
    @Inject(MAT_DIALOG_DATA) public datoPasado:any,
    private dialogRef:MatDialogRef<SolicitarCodigoComponent>,
    private codigoRegistroBl:CodigoRegistroBlService,
    private functionService: FunctionsService,
  ) { }

  ngOnInit(): void {

  }
  onClose(){
    this.uiService.CloseModalSolicitarCodigo();
  }


  onSubmit(form: NgForm) {
    if(form.valid){
      this.isLoading = true;
      this.codigoRegistroBl.getCodigoLectura(Number(form.value.resultado),form.value.email).then(async objCod=>{
        if(objCod!=null){
           const fechaServer = moment(await this.functionService.GetDateServer()).local().format();
           const fechaActual = new Date(fechaServer);           
           const fechaCreacion = new Date(objCod.fecha_creacion);
           const result = this.superoHora(fechaCreacion,fechaActual)
           if(result){
            this.uiService.ShowSnackBar(SnackBarType.ERROR, Msjs.MSJ_CODIGO_SUPERO_HORA, 3000);
            this.isLoading = false;
           }else{
            this.codigoRegistroBl.updateValidezCodigo(objCod.id!).then(result=>{
              if(result){
                this.uiService.ShowSnackBar(SnackBarType.INFO, Msjs.MSJ_CODIGO_OK_NUEVO_USUARIO, 3000);
                //actualizar codigo a no valido
                this.isLoading = false;
                this.onClose();
                this.uiService.showModalLogin({operacion:SistType.REGISTRO});
              }else{
                this.uiService.ShowSnackBar(SnackBarType.ERROR, Msjs.MSJ_CODIGO_ERROR_TRANSACCIONAL, 3000);
              }});            
           }           
        }else{
          this.uiService.ShowSnackBar(SnackBarType.ERROR, Msjs.MSJ_NO_CODIGO_NO_CORREO, 3000);
        }
      })
    }  
  }

  superoHora(fechaCreacion: Date, fechaActual: Date): boolean {
    // Calcula la diferencia en milisegundos
    const diferenciaMs = fechaActual.getTime() - fechaCreacion.getTime();  
    // Una hora en milisegundos
    const unaHoraMs = 60 * 60 * 1000;  
    // Retorna true si ya pasó una hora o más
    return diferenciaMs >= unaHoraMs;
  }

}
